import useFacilitiesWithIcons from '@/hooks/useFacilitiesWithIcons';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { faSparkles } from '@fortawesome/pro-duotone-svg-icons';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { faCheckCircle, faChevronDown, faLocationDot, faTag, faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import { memo, useState } from 'react';
import FavouriteButtonHotel from '../favouriteButtonHotel';
import NoImage from "../illustratores/NoImage";
import ImageLoading from "../ImageLoading";
import NextLink from '../NextLink';
import Button from '../ui/Button';
import TypingEffect from '../ui/TypingEffect';
import { Provider1FormattedHotelType } from './utils/provider1FormatHotel';
import AiStar from '../icons/AiStar';
import DiscountTag from './DiscountTag';
import { isBlackListed } from '@/utils/blacklistChecker';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/Carousel'
import { formatImageThumbnail } from './utils/formatImageThumbnail';


const CardVertical = memo(({ hotel, navigateTo, onNavigate, onImageClick, showCity, onClick, }:
  {
    showCity?: boolean;
    navigateTo: string,
    hotel: Provider1FormattedHotelType;
    onNavigate?: () => void,
    onImageClick?: () => void
    onClick?: () => void;
    // customButton?: ReactNode,
  }) => {

  const facils = useFacilitiesWithIcons(hotel.facilities)

  const [isLoading, setIsLoading] = useState(false)
  const [showDesc, setShowDesc] = useState(false)

  const { params: { prompt } } = useSetSearchParams()

  return (

    <div
      key={hotel.code}
      onClick={onClick}
      className={`${onClick ? 'cursor-pointer' : ''}
            ${showDesc ? 'grid-cols-1' : 'grid-cols-[0.58fr,_1fr,] '}
           relative  overflow-hidden z-0 rounded-3xl grid
      border bg-white shadow-lg md:shadow-none md:border-0 md:rounded-none transition-transform duration-300 hover:scale-[101%]
      
        lg:grid-cols-[220px,_1fr] lg:gap-2 `}
    >
      {showDesc && <FontAwesomeIcon
        onClick={(e) => {
          e.stopPropagation();
          setShowDesc(false);
        }}
        icon={faX}
        className='absolute  z-50 text-gray-600 md:hidden top-3 right-3 p-1.5 text-xs'
      />}
      <Carousel className={`${onImageClick ? 'cursor-pointer' : ''}
            ${!showDesc ? '' : 'hidden p-2 lg:p-0 lg:grid'}
           grid grid-cols-1   min-h-28 lg:min-h-[211px] 
           items-center md:rounded-3xl overflow-hidden`}>
        <CarouselContent>
          {hotel.images.map(image => <CarouselItem key={image.id}
            onClick={(e) => {
              e.stopPropagation()
              onImageClick && hotel.images.length > 0 && onImageClick()
            }}
            className='w-full h-full min-h-full '
          >

            {hotel.images ? (
              <div className='relative  md:rounded-3xl  min-w-20 md:min-w-[220px] md:min-h-[211px]   overflow-hidden w-full h-full'>
                <ImageLoading
                  width={270}
                  height={270}
                  src={formatImageThumbnail(image?.url)}
                  alt="room"
                  className="w-full md:absolute  !opacity-100 rounded-none min-h-52 object-cover h-full md:aspect-square "
                />
                {!!prompt && (!isLoading ? (!!hotel.matchPercentage) &&
                  <button onClick={(e) => {
                    e.stopPropagation()
                    setShowDesc(s => !s)
                  }} className='bg-indigo-50 absolute z-50 left-1/2 -translate-x-1/2 bottom-1 w-fit flex lg:hidden rounded-full items-center 
                                gap-1 px-2 py-1.5'
                  >
                    <AiStar className='w-5' />
                    <span className='bg-ai text-transparent bg-clip-text text-sm font-semibold'>{hotel.matchPercentage}%</span>
                    <FontAwesomeIcon className='text-xs' icon={faChevronRight} />
                  </button> : prompt &&
                <span className='bg-indigo-50 absolute z-50 right-1 bottom-1 w-fit flex lg:hidden rounded-full items-center 
                                gap-1 px-2.5 py-1'>
                  <FontAwesomeIcon icon={faSparkles} className={`${showDesc ? 'rotate-180' : ''} block transition-transform duration-200 text-purple-700 text-sm animate-pulse`} />
                </span>
                )}
              </div>
            ) : (
              <div className="flex rounded-none overflow-hidden h-full  w-full items-center justify-center lg:rounded-l-2xl bg-gray-200 object-cover text-gray-400 lg:aspect-[1.3/1] lg:rounded-2xl xl:h-full xl:w-full">
                <NoImage />
              </div>
            )}
          </CarouselItem>)}
        </CarouselContent >
        <CarouselPrevious className='!size-8 !bg-black/50 !text-white !backdrop-blur-sm !left-3' />
        <CarouselNext className='!size-8 !bg-black/50 !text-white !backdrop-blur-sm !right-3' />
      </Carousel>


      <div className='grid md:rounded-3xl md:border p-2 md:p-4 lg:grid-cols-[1fr,_auto]'>
        <div className=' relative'>

          <NextLink
            onClick={onNavigate}
            href={navigateTo}
            className={`${showDesc ? 'z-0' : 'z-10'} absolute left-0 top-0  h-full w-full `}>
          </NextLink>

          <div className={`${showDesc ? 'pl-2 pt-2 pb-1' : 'py-1'} flex flex-col gap-1.5  `}>
            <p className=" text-base font-bold   sm:mt-0  line-clamp-2">
              {hotel.name}
              {/* {isActive &&
                <FontAwesomeIcon className='text-[#3897F1]  ml-1'
                  icon={faBadgeCheck} />} */}
            </p>

            <div className="flex items-center gap-4">
              <div className=" flex items-center gap-2 ">
                <div className="flex text-xs capitalize text-amber-400 flex-row items-center gap-.5">
                  {hotel.stars}
                </div>
              </div>

            </div>
            {showCity && <h3 className="capitalize grid grid-cols-[16px,_1fr] line-clamp-1 text-xs 
                   items-center gap-2 font-normal text-gray-500">
              <span className='text-xs justify-self-center'>
                <FontAwesomeIcon icon={faLocationDot} />
              </span>
              <span>  {hotel.city}</span>
            </h3>}
            <AnimatePresence>
              {showDesc ? hotel.aiDescription &&
                <motion.div
                  initial={{ opacity: 0 }}
                  exit={{ opacity: 0 }}
                  animate={{ opacity: 100 }}
                  className={` bg-secondary-50 z-50 p-2 relative hidden lg:block w-full rounded-lg`}>
                  <div className={`${isLoading ? 'animate-pulse' : ''} flex items-center gap-1`}>
                    <FontAwesomeIcon icon={faSparkles} className='text-purple-700 text-sm' />
                    <span className='bg-ai text-xs text-transparent bg-clip-text'>
                      Personalized Match Details
                    </span>
                  </div>
                  <FontAwesomeIcon onClick={(e) => {
                    e.stopPropagation()
                    setShowDesc(false)
                  }} icon={faX} className='absolute text-gray-700 top-1 right-1 p-1 text-xs' />
                  {hotel.aiDescription && <p className='mt-2 text-sm font-normal'>
                    <TypingEffect typingSpeed={80} className='text-sm' word>{hotel.aiDescription}</TypingEffect>
                  </p>}
                </motion.div> : ((!!prompt)) && hotel.aiDescription &&
              <div className='bg-ai p-0.5 rounded-full w-fit'>
                <div onClick={(e) => {
                  e.stopPropagation()
                  !isLoading && setShowDesc(true)
                }}
                  className={`${isLoading ? 'animate-pulse' : ''} relative z-50 bg-white rounded-full  p-2 w-fit hidden lg:flex items-center gap-1`}>
                  <FontAwesomeIcon icon={faSparkles} className='text-purple-700 text-sm ' />
                  <span className='bg-ai text-xs text-transparent bg-clip-text'>
                    Personalized Match Details
                  </span>
                  <FontAwesomeIcon icon={faChevronRight} className='text-xs text-purple-700' />
                </div>
              </div>}
            </AnimatePresence>
          </div>
          {/* {hotel.nearby && hotel.nearby.name && <div
            className={`
                  mt-2
                   rounded-m capitalize grid grid-cols-[16px,_1fr] line-clamp-1 text-xs 
                   items-center gap-2 font-normal text-gray-500`}
          >
            <span className='text-xs justify-self-center'>
              <FontAwesomeIcon icon={faLocationDot} />
            </span>
            <div>
              <span>{hotel.nearby.name}:</span>{' '}
              <span>{hotel.nearby.distance}</span>

            </div>
          </div>} */}


          {!showDesc ? (
            <div className='mt-2 grid lg:grid-cols-2 lg:grid-rows-3 mb-1 gap-1.5 relative'>
              <div
                key="facilities"

                className="contents"
              >
                {facils?.slice(0, 5).map((item, index) => !isBlackListed(item.iconName) && (
                  <div
                    key={index}
                    className={`
              ${index < 2 ? 'hidden lg:grid' : ''}
              rounded-m capitalize  grid grid-cols-[16px,_1fr] line-clamp-1 text-xs 
              items-center gap-2 font-medium text-gray-700
            `}
                  >
                    <span className='text-xs justify-self-center'>
                      {item.iconElement || (
                        <FontAwesomeIcon className='text-gray-500' icon={faCheckCircle} />
                      )}
                    </span>
                    <div className='line-clamp-1'>
                      <span>{item.iconName}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) :
            <div
              key="description"


              className='w-full col-span-2 p-2'
            >
              <div className='w-full z-500 col-span-2 lg:hidden rounded-lg bg-secondary-50 p-1 relative'>

                <div className='flex items-center w-full justify-between mb-2 gap-1'>
                  <div className='flex items-center gap-1'>
                    <FontAwesomeIcon icon={faSparkles} className='text-purple-700 text-sm' />
                    <span className='bg-ai text-xs text-transparent bg-clip-text'>
                      Match Details
                    </span>
                  </div>
                  <div className='flex items-center gap-1'>
                    <AiStar />
                    <span>{hotel.matchPercentage}%</span>
                  </div>
                </div>
                <p className='w-full text-xs bg-ai text-transparent bg-clip-text'>{hotel.aiDescription}</p>
              </div>
            </div>
          }




        </div>

        <div className='pr-1 md:pr-0 relative lg:col-span-1 flex-wrap grid grid-cols-[1fr,_auto] items-end 
                        border-dashed lg:borer-t-0 '>

          {/* Desktop Rate */}
          <AnimatePresence>
            {(!!prompt) && (isLoading ? <motion.span
              initial={{ opacity: 0, y: -6 }}
              exit={{ opacity: 0, y: -6 }}
              animate={{ opacity: 100, y: 0 }}
              className='bg-indigo-50 hidden absolute top-2 right-2 lg:flex w-fit rounded-full items-center gap-1 px-2 py-1'>
              <FontAwesomeIcon icon={faSparkles} className='text-purple-700 text-sm ' />
              <span className='bg-ai text-transparent bg-clip-text font-semibold text-xs'>Calculating Match...</span>
            </motion.span> : (!!hotel.matchPercentage) && <motion.span
              initial={{ opacity: 0, y: -6 }}
              exit={{ opacity: 0, y: -6 }}
              animate={{ opacity: 100, y: 0 }}
              className='bg-indigo-50 hidden absolute top-2 right-2 lg:flex w-fit rounded-full items-center gap-1 px-2 py-1'>
              <FontAwesomeIcon icon={faSparkles} className='text-purple-700 text-sm ' />
              <span className='bg-ai text-transparent font-semibold bg-clip-text text-xs'>{hotel.matchPercentage}% Matched</span>
            </motion.span>)}
          </AnimatePresence>



          <div className={
            `${!showDesc ? '' : 'hidden lg:flex'}
              lg:pt-2 lg:col-span-1 h-full flex lg:w-full flex-col items-end justify-end
               gap-1 pb-2 pl-6 pr-2 lg:border-l border-dashed`} >
            <span className='grow'></span>
            {hotel.offer &&
              <DiscountTag className='!relative mr-2 mb-1' discountPercent={hotel.discountPercent} />
            }

            <div className='flex items-center gap-2'>
              {hotel.offer && hotel?.originalPrice &&
                <span className='text-red-600 line-through text-xs font-normal'>
                  {hotel?.originalPricePerNight}
                </span>
              }
              <span className="text-lg font-bold text-gray-800">
                {hotel.pricePerNight}
              </span>
            </div>
            <p className="mb-1 text-xs text-right font-semibold ">
              {hotel.totalPrice && <span className="text-gray-800 text-right text-xs font-normal"> Total Price: </span>}
              {hotel.totalPrice}
            </p>
            <NextLink
              onClick={onNavigate}
              href={navigateTo}
              className='hidden lg:block'>
              <Button radius='rounded-xl' color='secondary'>
                Check Availability
              </Button>
            </NextLink>

          </div>

        </div>
      </div>
      {!showDesc && <div className='absolute top-1 left-2 flex items-center gap-2 z-50'>
        <div className="size-6 rounded-xl    z-50 block ">
          <FavouriteButtonHotel hotelId={hotel.id} />
        </div>

      </div>}
    </div >

  );
});

CardVertical.displayName = 'CardVertical';
export default CardVertical;
